// Module
var code = "<div class=\"element-layout -read\"> <figure> <div view=\"Html\" data-html=\"[[ html ]]\" class=\"text-style -para\"></div> <figcaption class=\"text-style -caption\">[[ caption ]]</figcaption> </figure> </div>";
// Exports
export default code;